/* src/app/auth/forgot-password/forgot-password.component.scss */
/*# sourceMappingURL=forgot-password.component-RZSJO43J.css.map */
